<template>
  <el-dialog
      v-if="dialogVisible"
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="快递信息"
      width="1000px">
    <el-form ref="form" :model="form">
      <el-row>
        <el-col :span="8">
          <el-form-item label="快递类型：">{{form.logisticsName}}</el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="快递单号：">{{form.logisticsOrderNO}}</el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="快递状态：">{{form.logisticsStatus}}</el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="更新时间：">{{form.logisticsUpdateTime}}</el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-table
        ref="vmTable"
        module="basic"
        border
        :data="form.logisticsLogList">
      <el-table-column prop="time" label="时间" align="left" width="150"/>
      <el-table-column prop="status" label="状态" align="left"/>
    </el-table>
  </el-dialog>
</template>

<script>

  export default {
    name: "SapDeliveryLogisticsRecord",
    components: {},
    data() {
      return {
        dialogVisible: false,
        form: {
        },
      };
    },
    methods: {
      open(row) {
        this.dialogVisible = true;
        this.form = row;
      },
    },
  };
</script>

<style scoped>

</style>